module.exports = __webpack_public_path__ + "img/success.324ca420.svg";